import qs from 'qs'
import config from '../../config'
import { buildGetQuery } from '../../util'
import { QueryObserverOptions } from '@tanstack/react-query'

import { IGetRequestObject, ITrainingEventRecent } from '../../interfaces'

type QueryObject = {
  limit?: number,
  since?: string
}

const getRecentTrainingEventsRequest = (
  params: undefined,
  queryObject: QueryObject | undefined,
): IGetRequestObject => {
  const queryString = qs.stringify(queryObject, { addQueryPrefix: true })
  return {
    method: 'get',
    url: `${config.baseUrl}/training/compliance/recent-events${queryString}`,
  }
}

const useRecentTrainingEventsQueryBase = buildGetQuery<
  undefined,
  QueryObject | undefined,
  ITrainingEventRecent[] | undefined
>({
  getRequest: getRecentTrainingEventsRequest,
  getQueryKey: (params, queryObject) => [
    'recent-training-events',
    queryObject?.limit,
    queryObject?.since
  ],
})

const useRecentTrainingEventsQuery = (
  queryObject?: QueryObject,
  options?: QueryObserverOptions<ITrainingEventRecent[] | undefined, Error>,
) => {
  const recentTrainingEventsQuery = useRecentTrainingEventsQueryBase(
    undefined,
    queryObject,
    options,
  )
  return { ...recentTrainingEventsQuery }
}

export default useRecentTrainingEventsQuery